// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const gulpin: PokeData = {
  "id": 316,
  "name": "gulpin",
  "height": 4,
  "weight": 103,
  "base_experience": 60,
  "types": [
    PokeType.POISON
  ],
  "api_moves": [
    "pound",
    "toxic",
    "sludge",
    "amnesia",
    "poison-gas",
    "sludge-bomb",
    "pain-split",
    "encore",
    "stockpile",
    "spit-up",
    "swallow",
    "yawn",
    "wring-out",
    "gastro-acid",
    "gunk-shot",
    "acid-spray",
    "belch"
  ],
  "moves": [
    "poison-gas",
    "sludge-bomb",
    "mortal-gas",
    "toxic-overload",
    "venom-drench",
    "toxic-spikes",
    "poison-fang",
    "purify",
    "poison-powder",
    "acid-rain",
    "stun-spore",
    "poison-jab",
    "acid"
  ],
  "evolution_chain": {
    "id": 159,
    "item": null,
    "species": [
      {
        "name": "gulpin",
        "order": 344,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "swalot",
        "order": 345,
        "types": [
          PokeType.POISON
        ],
        "evolves_from_species_id": 316,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 26,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 61.5,
    "speed": 40,
    "ability_power": 43
  },
  "stat_changes": [],
  "catch_rate": 225,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
